import { useState, useEffect } from "react";
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Typography from "@mui/material/Typography";
import Divider from '@mui/material/Divider';
import AccordionMenu from "./AccordionMenu";
const SERVER_URL = `${process.env.REACT_APP_SITEURL}/`;
// const SERVER_URL = "http://localhost:3000/";



const DemoPaper = styled(Paper)(({ theme }) => ({
  width: "100%",
  // height: 120,
  padding: theme.spacing(2),
  ...theme.typography.body2,
  textAlign: 'center',
}));


const Slide1Content = ({ handleTutorialSlide }) => {

  return (
    <>
      <DemoPaper sx={{ my: .5, textAlign: "justify", p: 2 }} elevation={3} variant="elevation">
        <Typography sx={{ p: 1, fontWeight: "bolder", fontSize: "large" }}>
          سطح بندی لغات درون فیلم (CEFR)
        </Typography>
        <Typography sx={{ p: 1 }}>
          لغات هر زبان دارای سطح های مختلفی می باشند که این سطوح اغلب توسط زبان آموزان برای توضیح توانایی خود در صحبت کردن، خواندن، نوشتن و درک یک زبان مورد استفاده قرار می گیرد.
        </Typography>
        <Typography sx={{ p: 1 }}>
          استاندارد (Commen European Framework of Reference for Languages) CEFR مقیاسی با شش سطح است که از A1 شروع شده و تا C2 ادامه دارد. به‌طور خلاصه این شش سطح عبارتند از:
          <br />
          A1 (مبتدی‌ترین سطح)
          <br />
          A2
          <br />
          B1
          <br />
          B2
          <br />
          C1
          <br />
          C2 (پیشرفته‌ترین سطح)
          <br />
          سطح‌بندی مطابق استاندارد CEFR بسیار محبوب و پرکاربرد است؛ به‌طوری که برای نمره‌دهی آزمون‌های زبان در سراسر اروپا و تبدیل نمرات در آزمون آیلتس و تافل نیز استفاده می‌شود.
        </Typography>
        <Typography sx={{ textAlign: "center" }}>
          <img style={{ width: "60%" }} src={`${SERVER_URL}img/slider/slide5-img1.jpg`} />
        </Typography>
        <Typography sx={{ p: 1 }}>
          زبان آموز باید لغات را بر اساس سطح کاربری خود فراگیرد ، ما با تفکیک لغات بر اساس سطح آنها به زبان آموز این امکان را می دهیم تا لغات سطح خود را بصورت متمایز درون فیلم و زیرنویس مشاهده کند.
        </Typography>
        <Typography sx={{ p: 1 }}>
          همچنین زبان آموز می تواند از امکانات مختلف از جمله تغییر رنگ ، تغییر بک گراند ، توقف فیلم به مدت زمان دلخواه و تکرار دیالوگ برای یادگیری بهتر استفاده کند.
        </Typography>
        <Typography sx={{ textAlign: "center" }}>
          <img style={{ width: "60%" }} src={`${SERVER_URL}img/slider/slide5-img2.png`} />
        </Typography>
        <Typography sx={{ p: 1 }}>
          توجه : سطح بندی لغات در حال حاضر فقط برای زبان انگلیسی موجود می باشد.
        </Typography>
      </DemoPaper>
    </>
  )
}


export default Slide1Content;
